<script setup lang="ts">
import type { PlaceDetail } from '@consumer/types/serializers'
import newXIcon from '@consumer/assets/icons/new/x.svg?svgicon'

defineProps<{ place: PlaceDetail }>()

const emit = defineEmits<{ removePlace: [PlaceDetail] }>()
</script>

<template>
  <div
    class="places-tray-item text-xs lg:text-sm inline-flex items-center
    border-1 border-grey-primary rounded px-3 py-0.5 cursor-pointer underline-offset-4
    hover:underline hover:underline-offset-4 text-navy"
    style="border-color: rgb(209 213 219);"
  >
    {{ place.name }}
    <GIcon :svg="newXIcon" class="ml-2" size="18px" @click="emit('removePlace', place)"/>
  </div>
</template>
